export default __webpack_public_path__ + "static/media/Team-Bg.b55f25e0.png";